import _objectWithoutProperties from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from "react";
// Material imports
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog"; // Limitless imports

import RateFinishMessageFooter from "./RateFinishMessageFooter";

var RateFinishMessageOverlay = function RateFinishMessageOverlay(_ref) {
  var classes = _ref.classes,
      fullScreen = _ref.fullScreen,
      open = _ref.open,
      onCancelDialog = _ref.onCancelDialog,
      rest = _objectWithoutProperties(_ref, ["classes", "fullScreen", "open", "onCancelDialog"]);

  return /*#__PURE__*/React.createElement(Dialog, {
    open: open,
    disablePortal: true,
    transitionDuration: {
      enter: 500
    },
    classes: {
      paper: !fullScreen ? classes.paper : classes.fullScreenPaper
    },
    BackdropProps: {
      classes: {
        root: classes.backdrop
      }
    },
    style: {
      position: "absolute"
    },
    onBackdropClick: onCancelDialog
  }, /*#__PURE__*/React.createElement(RateFinishMessageFooter, Object.assign({}, rest, {
    onCancelDialog: onCancelDialog
  })));
};

var styles = function styles() {
  return {
    backdrop: {
      position: "absolute"
    },
    paper: {
      margin: 0,
      display: "block",
      maxHeight: "none"
    },
    fullScreenPaper: {
      margin: 0
    },
    "@media screen and (min-width: 450px)": {
      backdrop: {
        borderRadius: 12
      },
      paper: {
        borderRadius: 12
      }
    }
  };
};

export default withStyles(styles)(RateFinishMessageOverlay);